export class GetProductRequestParams {
  pageNo: number = 1;
  rowPerPage: number = 10;
  filter: string = '';
  providerCode: string | null = null;
  categoryCode: string | null = null;
  productCode: string | null = null;
  brand: string | null = null;
}

export class CreateProductParams {
  id: string = '';
  code: string = '';
  category: string = '';
  name: string = '';
  brand: string = '';
  price: string = '';
  selling_price: string = '';
  provider_code: string = '';
  provider_product: string = '';
  admin_fee: string = '0';
  active: string = '';
}

export class UpdateProductRequestParams extends CreateProductParams {
  oldPassword?: string;
}

export interface ProductData {
  id: string;
  code: string;
  category_code: string;
  name: string;
  brand: string;
  price: string;
  selling_price: string;
  provider_code: string;
  provider_product: string;
  admin_fee: string;
  active: string;
}

export interface GetProductResponse {
  code: number;
  message: string;
  data: ProductData[];
  currPage: number;
  haveNext: boolean;
  totalPage: number;
}

export interface GetProductByIdResponse {
  code: number;
  message: string;
  data: ProductData;
}

export interface DeleteProductByIdResponse {
  code: number;
  message: string;
  data: boolean;
}
